import { BaseProxy } from "@/proxies/BaseProxy";

export class TaskProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `task`,
      parameters,
    });
  }
}
